import DOMPurify from "dompurify";

/* strip any <hidden>…</hidden> first */
export function removeHidden(text = "") {
  return text.replace(/<hidden[^>]*>[\s\S]*?<\/hidden>/gi, "");
}

/* allow only Tweet‑like tags & attributes */
export function sanitiseHtml(dirty = "") {
  const safe = DOMPurify.sanitize(removeHidden(dirty), {
    ALLOWED_TAGS: [
      "p",
      "br",
      "strong",
      "em",
      "i",
      "b",
      "u",
      "a",
      "code",
      "pre",
      "blockquote",
      "ul",
      "ol",
      "li",
      "img",
      "h1",
      "h2",
      "h3",
      "h4",
      "span",
      "div",
      "sup",
      "sub",
      "mark",
      "small",
    ],
    ALLOWED_ATTR: ["href", "src", "alt", "title", "target", "style"],
    FORBID_TAGS: [
      "script",
      "style",
      "form",
      "input",
      "button",
      "textarea",
      "select",
      "option",
      "meta",
      "link",
      "base",
      "object",
      "embed",
      "param",
      "noscript",
      "iframe",
    ],
    FORBID_ATTR: [
      "onerror",
      "onload",
      "onclick",
      "onmouseover",
      "onmouseout",
      "onmouseenter",
      "onmouseleave",
      "onblur",
      "onfocus",
      "onchange",
      "onsubmit",
      "onreset",
      "onkeydown",
      "onkeypress",
      "onkeyup",
    ],
  });

  /* keep only "safe" inline‑styles (same list as PostCard) */
  const div = document.createElement("div");
  div.innerHTML = safe;

  const allowed = [
    "color",
    "background-color",
    "font-family",
    "font-size",
    "font-weight",
    "font-style",
    "text-decoration",
    "text-align",
    "line-height",
    "letter-spacing",
    "text-transform",
    "opacity",
    "margin",
    "padding",
  ];
  (function walk(el) {
    if (el.style) {
      const style = el.getAttribute("style");
      if (style) {
        const good = style.split(";").filter((s) => {
          const [prop] = s.split(":").map((p) => p.trim().toLowerCase());
          return allowed.includes(prop);
        });
        if (good.length) el.setAttribute("style", good.join(";"));
        else el.removeAttribute("style");
      }
    }
    [...el.children].forEach(walk);
  })(div);

  return div.innerHTML;
}
